import React from 'react'
import { Box } from '@mui/material';
import UserName from '../../components/dashboard/UserName';
import CreatePortfolioButton from '../../components/dashboard/portfolios/CreatePortfolioButton';
import ellipse_big from '../../assets/ellipse_big.svg';
import BubbleDesign from '../../components/dashboard/BubbleDesign';
import GlobalStatistics from '../../components/dashboard/GlobalStatistics';
import LatestsFunds from '../../components/dashboard/funds/LatestsFunds';


const HomePage: React.FC = () => {

    return <Box display={"flex"} margin={"0"} justifyContent={"center"} overflow={"auto"}>
        <Box display={"flex"} margin={"0 56px"} gap={"57px"} justifyContent={"center"}>
            <Box display={"flex"} flexDirection={"column"} margin={"60px 0"} gap={"32px"} width={"279px"} paddingBottom={"20px"}>
                <UserName />
                <CreatePortfolioButton />
                <LatestsFunds orientation='Vertical' />
            </Box>
            <Box sx={{ backgroundImage: `url(${ellipse_big})`, backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }} width={"1015px"} height={"880px"} display={"flex"} flexDirection={"column"} justifyContent={"space-between"} alignItems={"center"} marginTop={"-15px"} paddingBottom={"20px"}>
                <BubbleDesign />
                <GlobalStatistics />
            </Box>
        </Box>
    </Box>
}

export default HomePage;
